import { defineComponent, ref, computed, watch, onUnmounted, openBlock, createElementBlock, renderSlot, createTextVNode, toDisplayString } from "vue";
function dateParser(date) {
  const parsed = new Date(date);
  if (!Number.isNaN(parsed.valueOf())) {
    return parsed;
  }
  const parts = String(date).match(/\d+/g);
  if (parts == null || parts.length <= 2) {
    return parsed;
  } else {
    const [firstP, secondP, ...restPs] = parts.map((x) => parseInt(x));
    const correctedParts = [firstP, secondP - 1, ...restPs];
    const isoDate = new Date(Date.UTC(...correctedParts));
    return isoDate;
  }
}
function getNow() {
  return new Date().getTime();
}
function getNowString(time) {
  let date = new Date(time);
  let realMonth = date.getMonth() + 1;
  let month = realMonth < 10 ? `0${realMonth}` : realMonth;
  let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  return `${date.getFullYear()}-${month}-${day}`;
}
function getNowMoreString(time) {
  let date = new Date(time);
  let realMonth = date.getMonth() + 1;
  let month = realMonth < 10 ? `0${realMonth}` : realMonth;
  let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  let hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  let min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  return `${date.getFullYear()}-${month}-${day} ${hour}:${min}`;
}
function toTimestamp(input) {
  if (!isNaN(input) || /^\d+$/.test(input))
    return input;
  if (input instanceof Date)
    return input.getTime();
  input = (input || "").trim().replace(/\.\d+/, "").replace(/-/, "/").replace(/-/, "/").replace(/(\d)T(\d)/, "$1 $2").replace(/Z/, " UTC").replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2");
  return new Date(input).getTime();
}
var zh_TW = {
  short: {
    now: "\u525B\u525B",
    sec: " \u79D2",
    min: " \u5206",
    hour: " \u5C0F\u6642",
    day: " \u5929"
  },
  long: {
    now: "\u525B\u525B",
    sec: " \u79D2\u9418\u524D",
    min: " \u5206\u9418\u524D",
    hour: " \u5C0F\u6642\u524D",
    day: " \u5929\u524D"
  }
};
var zh_CN = {
  short: {
    now: "\u521A\u521A",
    sec: " \u79D2",
    min: " \u5206",
    hour: " \u5C0F\u65F6",
    day: " \u5929"
  },
  long: {
    now: "\u521A\u521A",
    sec: " \u79D2\u949F\u524D",
    min: " \u5206\u949F\u524D",
    hour: " \u5C0F\u65F6\u524D",
    day: " \u5929\u524D"
  }
};
function formatToLongString$g(time, type) {
  return `${time} ${type}${time > 1 ? "s" : ""} ago`;
}
var en = {
  short: {
    now: "just now",
    sec: "s",
    min: "m",
    hour: "h",
    day: "d"
  },
  long: {
    now: "just now",
    sec: (time) => formatToLongString$g(time, "second"),
    min: (time) => formatToLongString$g(time, "minute"),
    hour: (time) => formatToLongString$g(time, "hour"),
    day: (time) => formatToLongString$g(time, "day")
  }
};
var jp = {
  short: {
    now: "\u3059\u3053\u3057\u524D",
    sec: " \u79D2",
    min: " \u5206",
    hour: " \u6642\u9593",
    day: " \u65E5"
  },
  long: {
    now: "\u3059\u3053\u3057\u524D",
    sec: " \u79D2\u524D",
    min: " \u5206\u524D",
    hour: " \u6642\u9593\u524D",
    day: " \u65E5\u524D"
  }
};
function formatToLongString$f(time, type) {
  return ` ${time} ${type}${time > 1 ? "s" : ""} atr\xE1s`;
}
var es = {
  short: {
    now: "ahora mismo",
    sec: "s",
    min: "m",
    hour: "h",
    day: "d"
  },
  long: {
    now: "ahora mismo",
    sec: (time) => formatToLongString$f(time, "segundo"),
    min: (time) => formatToLongString$f(time, "minuto"),
    hour: (time) => formatToLongString$f(time, "hora"),
    day: (time) => formatToLongString$f(time, "dia")
  }
};
function formatToLongString$e(time, type) {
  return ` ${time} ${type}${time > 1 ? "s" : ""} atr\xE1s`;
}
var pt_BR = {
  short: {
    now: "agora",
    sec: "s",
    min: "m",
    hour: "h",
    day: "d"
  },
  long: {
    now: "agora",
    sec: (time) => formatToLongString$e(time, "segundo"),
    min: (time) => formatToLongString$e(time, "minuto"),
    hour: (time) => formatToLongString$e(time, "hora"),
    day: (time) => formatToLongString$e(time, "dia")
  }
};
var ar = {
  short: {
    now: "\u0642\u0628\u0644 \u0642\u0644\u064A\u0644",
    sec: " \u062B\u0627\u0646\u064A\u0629",
    min: " \u062F\u0642\u064A\u0642\u0629",
    hour: " \u0633\u0627\u0639\u0629",
    day: " \u064A\u0648\u0645"
  },
  long: {
    now: "\u0642\u0628\u0644 \u0642\u0644\u064A\u0644",
    sec: (time) => ` \u0642\u0628\u0644 ${time} \u062B\u0648\u0627\u0646\u064A`,
    min: (time) => ` \u0642\u0628\u0644 ${time} \u062F\u0642\u0627\u0626\u0642`,
    hour: (time) => ` \u0642\u0628\u0644 ${time} \u0633\u0627\u0639\u0627\u062A`,
    day: (time) => ` \u0642\u0628\u0644 ${time} \u0623\u064A\u0627\u0645`
  }
};
function formatToLongString$d(time, type) {
  return `il y a ${time} ${type}${time > 1 ? "s" : ""}`;
}
var fr = {
  short: {
    now: "maintenant",
    sec: "s",
    min: "m",
    hour: "h",
    day: "j"
  },
  long: {
    now: "maintenant",
    sec: (time) => formatToLongString$d(time, "seconde"),
    min: (time) => formatToLongString$d(time, "minute"),
    hour: (time) => formatToLongString$d(time, "heure"),
    day: (time) => formatToLongString$d(time, "jour")
  }
};
function formatToLongString$c(time, type) {
  return ` ${time} ${type}${time > 1 ? "s" : ""} temu`;
}
var pl = {
  short: {
    now: "przed chwil\u0105",
    sec: "s",
    min: "m",
    hour: "g",
    day: "d"
  },
  long: {
    now: "przed chwil\u0105",
    sec: (time) => formatToLongString$c(time, "sekund"),
    min: (time) => formatToLongString$c(time, "minut"),
    hour: (time) => formatToLongString$c(time, "godzin"),
    day: (time) => formatToLongString$c(time, "dni")
  }
};
function formatToLongString$b(time, type) {
  return ` ${time} ${type} \xF6nce`;
}
var tr = {
  short: {
    now: "\u015Fimdi",
    sec: "sn",
    min: "dk",
    hour: "s",
    day: "g"
  },
  long: {
    now: "\u015Fimdi",
    sec: (time) => formatToLongString$b(time, "saniye"),
    min: (time) => formatToLongString$b(time, "dakika"),
    hour: (time) => formatToLongString$b(time, "saat"),
    day: (time) => formatToLongString$b(time, "g\xFCn")
  }
};
function formatToLongString$a(time, type) {
  return ` ${time} ${type} yg lalu`;
}
var id = {
  short: {
    now: "baru saja",
    sec: "d",
    min: "m",
    hour: "j",
    day: "h"
  },
  long: {
    now: "baru saja",
    sec: (time) => formatToLongString$a(time, "detik"),
    min: (time) => formatToLongString$a(time, "menit"),
    hour: (time) => formatToLongString$a(time, "jam"),
    day: (time) => formatToLongString$a(time, "hari")
  }
};
function formatToLongString$9(time, type) {
  if (type == "zi") {
    if (time == 1)
      return "o zi \xEEn urm\u0103";
    else
      return time + " zile \xEEn urm\u0103";
  }
  return ` ${time == 1 ? "o " : time} ${type}${time == 1 ? "\u0103" : "e"} \xEEn urm\u0103`;
}
var ro = {
  short: {
    now: "chiar acum",
    sec: "s",
    min: "m",
    hour: "o",
    day: "z"
  },
  long: {
    now: "chiar acum",
    sec: (time) => formatToLongString$9(time, "secund"),
    min: (time) => formatToLongString$9(time, "minut"),
    hour: (time) => formatToLongString$9(time, "or"),
    day: (time) => formatToLongString$9(time, "zi")
  }
};
function formatToLongString$8(time, words) {
  let _time = time % 100;
  if (_time > 19) {
    _time = _time % 10;
  }
  switch (_time) {
    case 1: {
      return ` ${time} ${words[0]} \u043D\u0430\u0437\u0430\u0434`;
    }
    case 2:
    case 3:
    case 4: {
      return ` ${time} ${words[1]} \u043D\u0430\u0437\u0430\u0434`;
    }
    default: {
      return ` ${time} ${words[2]} \u043D\u0430\u0437\u0430\u0434`;
    }
  }
}
var ru = {
  short: {
    now: "\u0442\u043E\u043B\u044C\u043A\u043E \u0447\u0442\u043E",
    sec: "\u0441",
    min: "\u043C",
    hour: "\u0447",
    day: "\u0434\u043D"
  },
  long: {
    now: "\u0442\u043E\u043B\u044C\u043A\u043E \u0447\u0442\u043E",
    sec: (time) => formatToLongString$8(time, ["\u0441\u0435\u043A\u0443\u043D\u0434\u0430", "\u0441\u0435\u043A\u0443\u043D\u0434\u044B", "\u0441\u0435\u043A\u0443\u043D\u0434"]),
    min: (time) => formatToLongString$8(time, ["\u043C\u0438\u043D\u0443\u0442\u0430", "\u043C\u0438\u043D\u0443\u0442\u044B", "\u043C\u0438\u043D\u0443\u0442"]),
    hour: (time) => formatToLongString$8(time, ["\u0447\u0430\u0441", "\u0447\u0430\u0441\u0430", "\u0447\u0430\u0441\u043E\u0432"]),
    day: (time) => formatToLongString$8(time, ["\u0434\u0435\u043D\u044C", "\u0434\u043D\u044F", "\u0434\u043D\u0435\u0439"])
  }
};
function formatToLongString$7(time, type) {
  return `vor ${time} ${type}${time > 1 ? type === "Tag" ? "en" : "n" : ""}`;
}
var de = {
  short: {
    now: "Gerade eben",
    sec: "Sek.",
    min: "Min.",
    hour: "Std.",
    day: "Tg"
  },
  long: {
    now: "Gerade eben",
    sec: (time) => formatToLongString$7(time, "Sekunde"),
    min: (time) => formatToLongString$7(time, "Minute"),
    hour: (time) => formatToLongString$7(time, "Stunde"),
    day: (time) => formatToLongString$7(time, "Tag")
  }
};
function formatToLongString$6(time, words) {
  let _time = time % 100;
  if (_time > 19) {
    _time = _time % 10;
  }
  switch (_time) {
    case 1: {
      return ` ${time} ${words[0]} \u0442\u043E\u043C\u0443`;
    }
    case 2:
    case 3:
    case 4: {
      return ` ${time} ${words[1]} \u0442\u043E\u043C\u0443`;
    }
    default: {
      return ` ${time} ${words[2]} \u0442\u043E\u043C\u0443`;
    }
  }
}
var uk = {
  short: {
    now: "\u0449\u043E\u0439\u043D\u043E",
    sec: "\u0441",
    min: "\u0445\u0432",
    hour: "\u0433\u043E\u0434",
    day: "\u0434\u043D"
  },
  long: {
    now: "\u0449\u043E\u0439\u043D\u043E",
    sec: (time) => formatToLongString$6(time, ["\u0441\u0435\u043A\u0443\u043D\u0434\u0430", "\u0441\u0435\u043A\u0443\u043D\u0434\u0438", "\u0441\u0435\u043A\u0443\u043D\u0434"]),
    min: (time) => formatToLongString$6(time, ["\u0445\u0432\u0438\u043B\u0438\u043D\u0430", "\u0445\u0432\u0438\u043B\u0438\u043D\u0438", "\u0445\u0432\u0438\u043B\u0438\u043D"]),
    hour: (time) => formatToLongString$6(time, ["\u0433\u043E\u0434\u0438\u043D\u0430", "\u0433\u043E\u0434\u0438\u043D\u0438", "\u0433\u043E\u0434\u0438\u043D"]),
    day: (time) => formatToLongString$6(time, ["\u0434\u0435\u043D\u044C", "\u0434\u043D\u0456", "\u0434\u043D\u0456\u0432"])
  }
};
function formatToLongString$5(time, words) {
  if (time > 1) {
    return `\u043F\u0440\u0435\u0434\u0438 ${time} ${words[1]}`;
  }
  return `\u043F\u0440\u0435\u0434\u0438 ${time} ${words[0]}`;
}
var bg = {
  short: {
    now: "\u0441\u0435\u0433\u0430",
    sec: "\u0441",
    min: "\u043C",
    hour: "\u0447",
    day: "\u0434"
  },
  long: {
    now: "\u0441\u0435\u0433\u0430",
    sec: (time) => formatToLongString$5(time, ["\u0441\u0435\u043A\u0443\u043D\u0434\u0430", "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"]),
    min: (time) => formatToLongString$5(time, ["\u043C\u0438\u043D\u0443\u0442\u0430", "\u043C\u0438\u043D\u0443\u0442\u0438"]),
    hour: (time) => formatToLongString$5(time, ["\u0447\u0430\u0441", "\u0447\u0430\u0441\u0430"]),
    day: (time) => formatToLongString$5(time, ["\u0434\u0435\u043D", "\u0434\u043D\u0438"])
  }
};
function formatToLongString$4(time, type) {
  return `${time} ${time > 1 ? type[1] : type[0]} sen`;
}
var se = {
  short: {
    now: "alldeles nyss",
    sec: "s",
    min: "m",
    hour: "t",
    day: "d"
  },
  long: {
    now: "alldeles nyss",
    sec: (time) => formatToLongString$4(time, ["sekund", "sekunder"]),
    min: (time) => formatToLongString$4(time, ["minut", "minuter"]),
    hour: (time) => formatToLongString$4(time, ["timme", "timmar"]),
    day: (time) => formatToLongString$4(time, ["dag", "dagar"])
  }
};
function formatToLongString$3(time, type) {
  return `${time} ${type}${time > 1 ? "s" : ""} geleden`;
}
var nl = {
  short: {
    now: "zojuist",
    sec: "s",
    min: "m",
    hour: "h",
    day: "d"
  },
  long: {
    now: "zojuist",
    sec: (time) => formatToLongString$3(time, "seconde"),
    min: (time) => formatToLongString$3(time, "minuut"),
    hour: (time) => formatToLongString$3(time, "uur"),
    day: (time) => formatToLongString$3(time, "dag")
  }
};
function formatToLongString$2(time, type) {
  return `\u05DC\u05B4\u05E4\u05E0\u05B5\u05D9 ${type} ${time}`;
}
var he = {
  short: {
    now: "\u05D6\u05B6\u05D4 \u05E2\u05B7\u05EA\u05B8\u05D4",
    sec: "\u05E9\u05E0\u05D9\u05D5\u05EA",
    min: "\u05D3\u05B7\u05E7\u05B8\u05D4",
    hour: "\u05E9\u05C1\u05B8\u05E2\u05B8\u05D4",
    day: "\u05D9\u05B0\u05D5\u05B9\u05DD"
  },
  long: {
    now: "\u05D6\u05B6\u05D4 \u05E2\u05B7\u05EA\u05B8\u05D4",
    sec: (time) => formatToLongString$2(time, "\u05E9\u05E0\u05D9\u05D9\u05D4"),
    min: (time) => formatToLongString$2(time, "\u05D3\u05B7\u05E7\u05B8\u05D4"),
    hour: (time) => formatToLongString$2(time, "\u05E9\u05C1\u05B8\u05E2\u05B8\u05D4"),
    day: (time) => formatToLongString$2(time, "\u05D9\u05B0\u05D5\u05B9\u05DD")
  }
};
function formatToLongString$1(time, type) {
  return `${time} ${type}${time > 1 ? "\uCD08" : ""} \uC804`;
}
var ko = {
  short: {
    now: "\uC9C0\uAE08",
    sec: "\uCD08",
    min: "\uBD84",
    hour: "\uC2DC\uAC04",
    day: "\uC77C"
  },
  long: {
    now: "\uC9C0\uAE08",
    sec: (time) => formatToLongString$1(time, "\uCD08"),
    min: (time) => formatToLongString$1(time, "\uBD84"),
    hour: (time) => formatToLongString$1(time, "\uC2DC\uAC04"),
    day: (time) => formatToLongString$1(time, "\uC77C")
  }
};
function formatToLongString(time, type) {
  return `${time} ${type}\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27`;
}
var th = {
  short: {
    now: "\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49",
    sec: "\u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
    min: "\u0E19\u0E32\u0E17\u0E35",
    hour: "\u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
    day: "\u0E27\u0E31\u0E19"
  },
  long: {
    now: "\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49",
    sec: (time) => formatToLongString(time, "\u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"),
    min: (time) => formatToLongString(time, "\u0E19\u0E32\u0E17\u0E35"),
    hour: (time) => formatToLongString(time, "\u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"),
    day: (time) => formatToLongString(time, "\u0E27\u0E31\u0E19")
  }
};
var lang = {
  zh_TW,
  zh_CN,
  en,
  th,
  jp,
  ko,
  pt_BR,
  es,
  ar,
  fr,
  pl,
  tr,
  he,
  id,
  ro,
  ru,
  de,
  uk,
  bg,
  se,
  nl
};
class TimeAgo {
  constructor(dateTime, locale, type) {
    this.dateTime = dateTime;
    this.locale = locale || "en";
    this.type = type || "short";
  }
  setLocale(locale) {
    this.locale = locale;
  }
  getTimeAgoString(timer, type) {
    return typeof type === "string" ? `${timer}${type}` : type(timer);
  }
  getTimeAgo() {
    let { now, min, hour, day } = lang[this.locale][this.type];
    let timestamp = toTimestamp(this.dateTime);
    let nowTime = getNow();
    let timer = (nowTime - timestamp) / 1e3;
    let timeago = "";
    if (timer <= 0 || Math.floor(timer / 60) <= 0) {
      timeago = now;
    } else if (timer < 3600) {
      timeago = this.getTimeAgoString(Math.round(timer / 60), min);
    } else if (timer >= 3600 && Math.round(timer / 3600) < 24) {
      timeago = this.getTimeAgoString(Math.round(timer / 3600), hour);
    } else if (timer / 86400 <= 31) {
      timeago = this.getTimeAgoString(Math.round(timer / 86400), day);
    } else {
      timeago = getNowString(timestamp);
    }
    return {
      timeago,
      timestamp,
      nowString: getNowMoreString(timestamp)
    };
  }
}
const factory = (nowDate, { locale, type }) => new TimeAgo(nowDate, locale, type).getTimeAgo();
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;
const _sfc_main = defineComponent({
  name: "Timeago",
  props: {
    datetime: {
      type: [String, Date, Number],
      default: () => new Date()
    },
    locale: {
      type: String,
      default: "en"
    },
    long: {
      type: Boolean,
      default: true
    },
    minPeriod: {
      type: Number,
      default: 0
    },
    maxPeriod: {
      type: Number,
      default: WEEK
    }
  },
  emits: ["update"],
  setup(props, { emit }) {
    const timeago = ref("");
    const datetimeString = ref("");
    const timeoutId = ref(0);
    const seconds = ref(0);
    const timerConfig = computed(() => ({
      locale: props.locale,
      type: props.long ? "long" : "short"
    }));
    watch(ref(props), tick, { immediate: true, deep: true });
    function tick() {
      const then = dateParser(props.datetime).valueOf();
      if (!then) {
        console.warn("[vue2-timeago] Invalid Date provided");
        return;
      }
      const {
        timeago: formateValue,
        nowString,
        timestamp
      } = factory(props.datetime, timerConfig.value);
      seconds.value = Math.round(Math.abs(Date.now() - then) / 1e3);
      const unboundPeriod = seconds.value < MINUTE ? 1e3 : seconds.value < HOUR ? 1e3 * MINUTE : seconds.value < DAY ? 1e3 * HOUR : 1e3 * WEEK;
      const period = Math.min(Math.max(unboundPeriod, props.minPeriod * 1e3), props.maxPeriod * 1e3);
      timeago.value = formateValue;
      datetimeString.value = nowString;
      if (period) {
        if (timeoutId.value) {
          clearTimeout(timeoutId.value);
        }
        timeoutId.value = setTimeout(tick, period);
        emit("update", {
          timeago: formateValue,
          nowString,
          timestamp,
          seconds: seconds.value
        });
      }
    }
    onUnmounted(() => {
      if (timeoutId.value) {
        clearTimeout(timeoutId.value);
      }
    });
    return {
      timeago,
      seconds
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", null, [
    renderSlot(_ctx.$slots, "default", {
      timeago: _ctx.timeago,
      secondsElapsed: _ctx.seconds
    }, () => [
      createTextVNode(toDisplayString(_ctx.timeago), 1)
    ])
  ]);
}
var Timeago = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { Timeago };
